$(document).ready(function(){
    $("button[name='exportButton']").on("click", function() {


    });

});

function openExportModal(e, title) {
    if(title != null) {
        $('#exportModal .modal-title').text(title);
    }
    $("form[name='contratForm']").attr('action',e)
    if(e.indexOf("operations/export") >= 0) {
        location.href = e;
    } else {
        $('#exportModal').modal('show')
    }
}